import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeliveryAcsForm } from '@pt/models';

@Component({
  standalone: false,
  selector: 'pu-delivery-view-acs',
  templateUrl: './acs.component.html',
  styleUrls: ['./acs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcsComponent {
  delivery = input<DeliveryAcsForm>();
}
